export default "__VITE_ASSET__5077f47b__"